import type { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'

import { JEPX_AREA_CODES, convertAreaLabel } from '~/models/area'

// 共通 bidding コンポーネント (= SpotBidding / IntradayBidding) で使う
// AreaCode → 日本語エリア名 / 部分選択ラベルの helper。
// エリアの対象集合 (= 沖縄除外の 9 エリア) と並び・ラベル文言は canonical な
// ~/models/area (JEPX_AREA_CODES / convertAreaLabel = common:area.*) に集約し、
// ここでは bidding 固有の表示ロジック (= chart-area-label の連結規則) のみを持つ。

/** 単一エリア (= AreaCode) → 日本語ラベル。 JEPX 対象 (= 9 エリア) 以外は undefined。 */
export const areaLabelOf = (code: AreaCode): string | undefined =>
  JEPX_AREA_CODES.includes(code) ? convertAreaLabel(code) : undefined

/**
 * design HTML `spot.html` の `chart-area-label` 相当。
 * 全 9 エリア選択 = 「全エリア」、 部分選択 = エリア名を「・」で連結、 0 件 = 「未選択」。
 * `selectedAreas` はチェック中エリアの実集合 (= sentinel なし)。 並びは canonical な
 * JEPX_AREA_CODES (= 北→南) を SoT とする。
 */
export const buildSelectedAreasLabel = (
  selectedAreas: Set<AreaCode>,
): string => {
  if (selectedAreas.size === JEPX_AREA_CODES.length) return '全エリア'
  if (selectedAreas.size === 0) return '未選択'
  return JEPX_AREA_CODES.filter((code) => selectedAreas.has(code))
    .map((code) => convertAreaLabel(code))
    .join('・')
}
